// extracted by mini-css-extract-plugin
module.exports = {"edit-profile-form":"EditProfileForm_edit-profile-form__2j4pG","cta-wrapper":"EditProfileForm_cta-wrapper__1ogIZ","submit-button":"EditProfileForm_submit-button__3ocl7"};